import { createAction } from '@reduxjs/toolkit';
export var fetchTimezones = createAction('timezone/fetchTimezones');